import React, { useRef, useState, useCallback } from 'react'
import t from '~t'
import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { set } from '~data/actions/config'

import { Button, Icon, Popover, Layout, Radio, Label, Range } from '~ui'

const fonts = ['', 'serif', 'Palatino', 'Times New Roman', 'Trebuchet MS', 'georgia', 'verdana', 'monospace']

export default function ReaderHeaderSettings() {
    const dispatch = useDispatch()
    const font_size = useSelector(state => state.config.font_size)
    const font_color = useSelector(state => state.config.font_color)
    const font_family = useSelector(state => state.config.font_family)

    const pin = useRef(null)
    const [show, setShow] = useState(false)

    const onSettingsClick = useCallback(e => {
        e.preventDefault()
        setShow(prev => !prev)
    }, [])

    const onSettingsClose = useCallback(() => setShow(false), [])

    const onSettingChange = useCallback(
        e => {
            dispatch(
                set(e.currentTarget.getAttribute('data-key'), e.currentTarget.getAttribute('data-val'))
            )
        },
        [dispatch]
    )

    const onFontSizeChange = useCallback(
        e => {
            dispatch(set('font_size', e.target.value))
        },
        [dispatch]
    )

    const renderFont = useCallback(
        (font = '') => (
            <Radio
                key={font}
                checked={font_family == font}
                data-key='font_family'
                data-val={font}
                style={{ fontFamily: font }}
                onChange={onSettingChange}>
                {_.capitalize(font) || 'System'}
            </Radio>
        ),
        [font_family, onSettingChange]
    )

    return (
        <>
            <Button variant='ghost' ref={pin} title={t.s('settings')} onMouseDown={onSettingsClick}>
                <Icon name='settings' />
            </Button>

            {show && (
                <Popover pin={pin} onClose={onSettingsClose}>
                    <Layout>
                        <Label>{t.s('interfaceStyle')}</Label>
                        <div className={'ui-reader-switch'}>
                            <a className={'ui-swatch-auto' + ' ' + (font_color == '' ? 'ui-swatch-active' : '')} data-key='font_color' data-val='' onClick={onSettingChange}></a>
                            <a className={'ui-swatch-day' + ' ' + (font_color == 'day' ? 'ui-swatch-active' : '')} data-key='font_color' data-val='day' onClick={onSettingChange}></a>
                            <a className={'ui-swatch-sunset' + ' ' + (font_color == 'sunset' ? 'ui-swatch-active' : '')} data-key='font_color' data-val='sunset' onClick={onSettingChange}></a>
                            <a className={'ui-swatch-dark' + ' ' + (font_color == 'night' ? 'ui-swatch-active' : '')} data-key='font_color' data-val='night' onClick={onSettingChange}></a>
                        </div>

                        <Label>{t.s('fontFamily')}</Label>
                        <div>{fonts.map(renderFont)}</div>

                        <Label>{t.s('fontSize')}</Label>
                        <Range min='1' max='9' value={font_size} onChange={onFontSizeChange} />

                        <Button
                            variant='primary'
                            onClick={onSettingsClose}>
                            {t.s('done')}
                        </Button>
                    </Layout>
                </Popover>
            )}
        </>
    )
}
